import { getAuth } from './getAuth';
export const setupAuth = store => {
  return store.dispatch(getAuth());
};